import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  sellerAccountReducer,
  sendOtpReducer,
  userLoginReducer,
} from "../Reducers/userReducer";

const reducer = combineReducers({
  otpDetails: sendOtpReducer,
  auth: userLoginReducer,
  seller: sellerAccountReducer,
});

let initialState = {};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
